import {Component, Input} from '@angular/core';
import {BadgeProfile} from '../../interface/badge-profile';

@Component({
  selector: 'fb-badge-profile',
  templateUrl: './badge-profile.component.html',
  styleUrls: ['./badge-profile.component.scss']
})
export class BadgeProfileComponent {
	@Input() dataBadgeProfile: BadgeProfile = {} as BadgeProfile;

	public ngOnInit(): void {
		// console.log(this.dataBadgeProfile)
	}
}
